import React from 'react'
import { NotificationManager } from 'react-notifications'

import useFetch from '../../hooks/fetchMSSQL-hook'

const algorithms = [
  [1, 'Wg sumy sprzedaży', 'ExpectedCoinsValue1', 'primary', 'Sprzedaż z transakcji pomniejszona o zmianę liczników z maksymalnie 3 miesięcy'],
  [2, 'Wg liczników całkowitych', 'ExpectedCoinsValue2', 'secondary', 'Wartość wynikająca z całkowitych liczników sprzedaży'],
  [3, 'Wg monet wrzuconych do skrzynki', 'ExpectedCoinsValue3', 'danger', 'Różnica wartości monet wrzuconych do skrzynki'],
  [4, 'Wg sprzedaży gotówkowej', 'ExpectedCoinsValue4', 'warning', 'Wartość wynikająca z licznika sprzedaży gotówkowej'],
  [5, 'Wg liczników: ilość x średnia cena', 'ExpectedCoinsValue5', 'info', 'Różnica liczby sprzedaży pomnożona przez średnią cenę'],
  [6, 'Wg notowanych liczników: wartość', 'ExpectedCoinsValue6', 'dark', 'Różnica zapisanych wartości liczników sprzedaży'],
  [7, 'Wg paragonów', 'ExpectedCoinsValue7', 'success', 'Wartość wyliczona na podstawie pozycji paragonów'],
  [8, 'Wg banknociarki', 'ExpectedCoinsValue8', 'primary', 'Wartość wyliczona na podstawie przyjętych banknotów']
]

export default ({ data, handleClose, search }) => {
  const { fetchMssqlApi } = useFetch()

  const currentId = data?.DefaultCoinAlgoritmId == null ? null : Number(data.DefaultCoinAlgoritmId)
  const current = algorithms.find(([id]) => id === currentId)

  const money = value => `${Number(value || 0).toLocaleString('pl-PL', {minimumFractionDigits: 2, maximumFractionDigits: 2})} zł`

  const submit = coinAlgoritmId => {
    if (!data?.MachineCoinInventoryId) return NotificationManager.error('Brak identyfikatora KP')
    fetchMssqlApi('update-machine-coin-algorithm',
      {method: 'POST', hideNotification: true, data: { machineCoinInventoryId: data.MachineCoinInventoryId, coinAlgoritmId}},
      () => {NotificationManager.success('Zmieniono sposób wyliczania'); handleClose(); search()}
    )
  }

  return (
    <>
      <div className="modal d-block" tabIndex="-1" role="dialog">
        <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg" role="document">
          <div className="modal-content shadow">
            <div className="modal-header">
              <div>
                <h5 className="modal-title font-weight-bold mb-0">Sposób wyliczania KP</h5>
                <small className="text-muted">{data?.KP} · EVADTS: {data?.HasEVADTS || 'NIE'}</small>
              </div>
              <button type="button" className="close" onClick={handleClose}><span>&times;</span></button>
            </div>
            <div className="modal-body">
              <div className="row align-items-center mb-3">
                <div className="col-md-7">
                  <div className="font-weight-bold">{data?.MachineFullName}</div>
                  <div className="small text-muted">Stan wrzutnika: <strong className="text-dark">{money(data?.I)}</strong></div>
                  <div className="small text-muted">Zmiana stanu wrzutnika: <strong className="text-dark">{money(data?.H)}</strong></div>
                  <div className="small text-muted">Sprzedaż z paragonów: <strong className="text-dark">{money(data?.P)}</strong></div>
                  <div className="small text-muted">Wartość z banknociarki: <strong className="text-dark">{money(data?.Q)}</strong></div>
                </div>
                <div className="col-md-5 text-md-right mt-2 mt-md-0">
                  <small className="text-muted d-block">Aktualna wartość oczekiwana</small>
                  <h4 className="font-weight-bold mb-1">{money(data?.ExpectedCoinsValue)}</h4>
                  {current
                    ? <span className={`badge badge-${current[3]} px-2 py-1`}>{current[1]}</span>
                    : <span className="badge badge-danger px-2 py-1">BRAK ALGORYTMU</span>}
                </div>
              </div>
              {data?.Comment && data.Comment !== 'BRAK' && (
                <div className="alert alert-warning py-2 mb-3"><small><strong>Automatyczny komentarz:</strong> {data.Comment}</small></div>
              )}
              <div className="font-weight-bold mb-2">Dostępne algorytmy wyliczania</div>
              <div className="list-group">
                {algorithms.map(([id, name, field, color, description]) => {
                  const selected = currentId === id
                  return (
                    <button key={id} type="button" onClick={() => submit(id)} className={`list-group-item list-group-item-action ${selected ? 'active' : ''}`}>
                      <div className="d-flex justify-content-between align-items-center">
                        <div className="text-left pr-3">
                          <div className="font-weight-bold">{name}</div>
                          <small className={selected ? 'text-white' : 'text-muted'}>{description}</small>
                        </div>

                        <div className="text-right text-nowrap">
                          <strong className={selected ? 'text-white' : `text-${color}`}>{money(data?.[field])}</strong>
                          {selected && <div><span className="badge badge-light mt-1">Aktualny</span></div>}
                        </div>
                      </div>
                    </button>
                  )
                })}
                <button type="button" onClick={() => submit(null)} className={`list-group-item list-group-item-action ${currentId === null ? 'active' : ''}`}>
                  <div className="d-flex justify-content-between align-items-center">
                    <div className="text-left">
                      <div className={currentId === null ? 'font-weight-bold' : 'font-weight-bold text-danger'}>BRAK algorytmu</div>
                      <small className={currentId === null ? 'text-white' : 'text-muted'}>Wartość oczekiwana nie będzie wyliczana automatycznie</small>
                    </div>
                    {currentId === null && <span className="badge badge-light">Aktualny</span>}
                  </div>
                </button>
              </div>
            </div>

            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" onClick={handleClose}>Zamknij</button>
            </div>
          </div>
        </div>
      </div>

      <div className="modal-backdrop fade show" />
    </>
  )
}